import { create } from "zustand";

import { CampaignForm } from "../types/campaign";

import { ModelsCampaignV2RequestSkipCoppa, ModelsCampaignV2ModelSkipRewardedAd } from "@/schemas";
import { CampaignFormValues } from "@/shared/lib/validation/schemas";

interface StoreActions {
    flush: () => void;
    setCampaignInfo: (campaign: CampaignFormValues) => void;
    changeCampaignField: (
        field: keyof CampaignFormValues,
        value: CampaignFormValues[keyof CampaignFormValues],
    ) => void;
}

const initState = {
    campaign: {
        app_uuid: "",
        start_date: null,
        end_date: null,
        name: "",
        description: "",
        target_id: "",
        tracking_link_id: "",
        skip_rewarded_ad: "UnsetRewardedType" as ModelsCampaignV2ModelSkipRewardedAd,
        skip_coppa: "Unset" as ModelsCampaignV2RequestSkipCoppa,
        bet_cpm: 0,
        erid: "",
        contract_uuid: "",
        daily_budget_const: 0,
        all_budget_const: 0,
        status: "Active" as const,
    },
};

export const useCampaignFormStore = create<CampaignForm & StoreActions>((set) => ({
    ...initState,

    flush: () => set(initState),
    setCampaignInfo: (campaign) => {
        set({ campaign });
    },

    changeCampaignField: (field, value) =>
        set((state) => ({
            campaign: {
                ...state.campaign,
                [field]: value,
            },
        })),
}));
